import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    getUnknownWorkflowContextIdentifiers,
    getWorkflowContextExpressionSyntaxResult,
} from '../services/workflowContextExpression';

import './ContextPathSyntaxFeedback.scss';

/**
 * Inline validation for workflow custom context paths (errors only).
 *
 * @param {{ value: string, knownPaths?: Set<string>|string[] }} props
 */
export default function ContextPathSyntaxFeedback({ value, knownPaths }) {
    const { t } = useTranslation();
    const syntax = getWorkflowContextExpressionSyntaxResult(value);
    const unknown = getUnknownWorkflowContextIdentifiers(value, knownPaths);

    if (syntax.level === 'error') {
        return (
            <span className="context-path-syntax-feedback--error" role="alert">
                {t(`workflows.context_expr.${syntax.key}`)}
            </span>
        );
    }
    if (unknown.length > 0) {
        return (
            <span className="context-path-syntax-feedback--error" role="alert">
                {t('workflows.context_expr.unknown_identifiers', { list: unknown.join(', ') })}
            </span>
        );
    }
    return null;
}
